import { Flex } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PlantingGroupStageCount } from 'screens/season-overview/types';
import { LegendText } from '../common/Legend';

const CustomLegendData = ({
  planting,
  onboarding,
  collections,
  closed,
  colorsInOrder,
}: PlantingGroupStageCount & { colorsInOrder: string[] }) => {
  const { t } = useTranslation();

  const data = useMemo(
    () => [
      {
        legend: t('seasonOverview.widgets.plantingGroupStages.onboarding'),
        value: onboarding || 0,
        color: colorsInOrder[0],
      },
      {
        legend: t('seasonOverview.widgets.plantingGroupStages.planting'),
        value: planting || 0,
        color: colorsInOrder[1],
      },
      {
        legend: t('seasonOverview.widgets.plantingGroupStages.collections'),
        value: collections || 0,
        color: colorsInOrder[2],
      },
      {
        legend: t('seasonOverview.widgets.plantingGroupStages.closed'),
        value: closed || 0,
        color: colorsInOrder[3],
      },
    ],
    [onboarding, planting, collections, closed, colorsInOrder],
  );

  return (
    <Flex vertical className="w-100">
      {data?.map((legend, index) => <LegendText legend={legend} key={index} />)}
    </Flex>
  );
};

export default CustomLegendData;
